import React from 'react'

import styles from './contentmain.module.css'

type Props = React.PropsWithChildren<{}>

const ContentMain = ({ children }: Props) => {
  return <main className={styles.application}>{children}</main>
}

export default ContentMain
